//auth
export const API_LOGIN = "/auth/login";
export const API_LOGOUT = "/auth/logout";
export const API_VALIDATE_TOKEN = "/auth/validate-token";
export const API_CHANGE_PASSWORD = "/auth/change-password";
export const API_MFA_SETUP = "/auth/mfa/setup";
export const API_MFA_ENABLE = "/auth/mfa/enable";
export const API_MFA_DISABLE = "/auth/mfa/disable";
export const API_MFA_VERIFY = "/auth/mfa/verify";
export const API_MFA_RECOVER = "/auth/mfa/recover";
export const API_SESSION = "/auth/sessions";
export const API_ME = "/auth/me";
export const API_RESTART = "/user/restart-all";
export const API_FORCE_LOGOUT = "/auth/admin/force-logout";
export const API_FORCE_DISABLE_MFA = "/auth/admin/force-disable-mfa";
export const API_RESET_PASSWORD = "/auth/admin/reset-password";

//common
export const API_GET_WHITE_LABEL_SETTING = "/whiteLabelSetting";
export const API_POST_CHECK_USER = "/user/checkUser";
export const API_VIEW_BET = "/placebet/get-all-viewbet/matchId";
export const API_GET_CURRENCY = "/currency";
export const API_WHITE_LABEL_WELCOME = "/white-lable-welcome-massage";

//webhook setting
export const API_GET_ALL_SETTINGS = "/webHook/getallsettings";
export const API_GET_WEBHOOK_RESTRICTION = "/webHook/getRestriction";
export const API_PUT_WEBHOOK_RESTRICTION = "/webHook/updateRestriction";

// Game = sport
export const API_GET_FILTER_SPORT = "/eventtype/options";
export const API_SPORT = "/eventtype";

// tournament
export const API_GET_FILTER_TOURNAMENT = "/competition/options";
export const API_TOURNAMENT = "/competition";

// match
export const API_MATCH = "/event";
export const API_GET_MATCHBYID = "/match/byId";
export const API_UPDATE_IMPORTFANCY = "/match/importFancy";
export const API_GET_GETALLCHANNELS = "/match/getAllChannel";
export const API_UPDATE_EDITMATCHLIVETV = "/match/chennel";
export const API_UPDATE_MATCHIMPORTTIME = "/match/openDate";
export const API_POST_MATCHSETTLED = "/match/settled";
export const API_MATCH_MARKET_RESULT = "/match/marketResult";

// market
export const API_MARKET = "/market";
export const API_GET_ALL_MATCH = "/event/options";
export const API_UPDATE_MARKETBYTYPE = "/market/updateMarketByType";
export const API_POST_MARKET_REPORT = "/market/report";
export const API_GET_LINE = "/market/line";
export const API_GET_BOOKMAKER = "/market/bookmaker";
export const API_GET_ODDEVEN = "/market/get-all-OddEven";
export const API_ADD_CREATEFANCY = "/market/createfancy";
export const API_UPDATE_COMMENTARY = "/market/commentory";
export const API_UPDATE_MATCHBYSTATUS = "/market/updateMatchByStatus";
export const API_UPDATE_COMMENTARYSTATUS_MARKET = "/market/commentory";
export const API_GET_MARKETBYID = "/market/getmarketById";
export const API_GET_IMAGES = "/market/getImages";
export const API_POST_IMAGES = "/market/addImages";
export const API_DELETE_IMAGES = "/market/deleteImages";
export const API_UPDATE_IMAGES = "/market/updateImages  ";
export const API_GET_PAYMENT_GATEWAY = "/market/getGateway";

// markeet config
export const API_GET_MARKET_CONFIG = "/marketapi/get";
export const API_CREATE_MARKET_CONFIG = "/marketapi/create";
export const API_STATUS_MARKET_CONFIG = "/marketapi/status";

// bookmaker
export const API_GET_BOOKMAKERSETTINGS = "/bookmakerSetting";
export const API_POST_SETTLEBOOKMAKER = "/bookmaker/settled";
export const API_BOOKMAKER_LATEST_RATE = "/bookmaker/bookmaker-latest-rate";
export const API_BOOKMAKER_ADD_RATE = "/bookmaker/add-bookmaker-rate";

// fancy
export const API_COMMON_FANCY = "/fancy";
export const API_GET_FANCYSETTINGS = "/fancySetting";
export const API_POST_SETTLEFANCY = "/fancy/fancySettle";
export const API_FANCY_CONFIGURE = "/fancyConfigure";
export const API_FANCY_VOLUME = "/fancy/get-volume";
export const API_FANCY_LATEST = "/fancy/get-latest-rate";
export const API_FANCY_SETTING = "/fancy/update-fancy-setting";
export const API_FANCY_RATE = "/fancy/add-fancy-rate";

// user
export const API_USER = "/user";
export const API_UPDATE_PASSWORD = "/user/resetpassword";
export const API_GET_IMPORT_INDIA_FANCY = "/user/active-game-india";
export const API_GET_IMPORT_INDIA_FANCYDETAILS = "/user/active-market-india";
export const API_GET_IMPORTRADHEFANCY = "/user/active-game-samudra-new";
export const API_GET_IMPORTRADHEFANCYDETAILS = "/user/active-market-samudra";
export const API_GET_FANCYUSERS = "/user/fancyuser";
export const API_GET_USERGLOBALSETTINGS = "/userGlobalSetting";
export const API_DASHBOARD_COUNT = "/user/getDashboard";
export const API_UPDATE_USER_STATUS = "/user/updatestatus";
export const API_LOCK_USER = "/auth/admin/lock-user";
export const API_UNLOCK_USER = "/auth/admin/unlock-user";
export const API_DELETE_USER = "/user";
export const API_USER_EVENT_TYPE = `${API_USER}/eventtype/options`;
export const API_USER_OPTIONS = `${API_USER}/options`;
export const API_USER_ROLE_OPTIONS = `${API_USER}/role/options`;
export const API_USER_EVENT_SHARING = `${API_USER}/eventtype/shared`;

// commentary
export const API_ADD_COMMENTARY = "/commentary/create";
export const API_GET_COMMENTARYLIST = "/commentary/list-all";
export const API_DELETE_COMMENTARY = "/commentary/delete";
export const API_UPDATE_COMMENTARYSTATUS = "/commentary/updateStatus";
export const API_EDIT_COMMENTARY = "/commentary/update";

// moduleAccess
export const API_GET_MODULES = "/moduleAccess";

// game setting
export const API_COMMON_GAME_SETTING = "/gameSetting";

// line-market
export const API_LINE_MARKET_SETTING = "/lineMarketSetting";
export const API_LINE_CONFIGURE = "/lineConfigure";

// import
export const IMPORT_SPORT = "/eventtype/import";
export const IMPORT_TOURNAMENT = "/competition/import";
export const IMPORT_MATCH = "/event/import";
export const IMPORT_MARKET = "/market/import";

// user
export const API_GET_USER_SESSION = "/user/session";

// usertype
export const API_USER_TYPE_OPTIONS = "/usertype/options";

// permission
export const API_PERMISSION = "/Permission";
export const API_UPDATE_PERMISSION = "/Permission/UpdateStatus";

//form
export const API_FORM = "/form";
export const API_UPDATE_FORM_STATUS = "/form/UpdateStatus";

//roles
export const API_ROLES = "/role";
export const API_UPDATE_ROLES_STATUS = "/role/updatestatus";
export const API_GET_ROLE_OPTIONS = "role/options";

// BettingType setting
export const API_GET_GAME_EVENTTYPE_OPTIONS = "/eventtype/options";
export const API_GET_BETTINGTYPE_SETTINGS = "/bettingtype/settings";
export const API_BETTINGTYPE_STATUS = "/bettingtype/settings/{id}";
export const API_BETTINGTYPE_EVENTTYPE_ID = "/bettingtype";
export const API_BETTINGTYPE_OPTIONS = "/bettingtype/options";

// MarketType setting
export const API_MARKETTYPE_SETTINGS = "/markettype/settings";
export const API_MARKETTYPE_STATUS = "/markettype/settings/{id}";
export const API_MARKETTYPE_OPTIONS = "/markettype/options";

// Tournament setting
export const API_TOURNAMENT_SETTING = "/competition/settings";

// Match (event) setting
export const API_MATCH_SETTING = "/event/settings";

// Market setting
export const API_MARKET_SETTING = "/market/settings";

// Report
export const API_GET_MARKET_OPERATION = "/marketoperation/runner";

//Whitelabel
export const API_WHITELABEL = "/whitelabel";
export const API_UPDATE_WHITELABEL_STATUS = "/whitelabel/updatestatus";

// Ignore Runner
export const API_UPDATE_IGNORE_RUNNERS = "/bettingtype";
export const API_POST_MARKET_OPERATION_RUNNERS = "/marketoperation/runner";

// Market Type
export const API_GET_MARKET_TYPE = "/markettype";
export const API_GET_OPEN_MARKET = "/marketoperation/open";
export const API_GET_CANCELLED_MARKET = "/marketoperation/cancelled";
export const API_GET_SETTLED_MARKET = "/marketoperation/settled";

// Dashboard
export const API_GET_DASHBOARD = "/dashboard";

// Event type
export const API_EVENT_TYPE = "/eventtype";
export const API_EVENT_TYPE_OPTIONS = `${API_EVENT_TYPE}/options`;

// White Labek
export const API_WHITE_LABEL = "/whitelabel";
export const API_WHITE_LABEL_OPTIONS = `${API_WHITE_LABEL}/options`;

export const API_DASHBOARD_MARKET = "/dashboard/market";

// Market Operation
export const API_MARKET_OPERATION_CANCEL = "/marketoperation/cancel";
export const API_MARKET_OPERATION_REOPEN = "/marketoperation/reopen";
export const API_MARKET_OPERATION_DELETE = "/marketoperation/delete";

// UserSession
export const API_USER_SESSION_HISTORY = "/usersession/history";
